import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 2,
  class: "pp-draw-results__results"
}

import { computed, onMounted, ref } from "vue";
import DsDropdown from "@sazka/design-system/src/forms/components/ds-dropdown.vue";
import DsSegmentedPicker from "@sazka/design-system/src/segmented-picker/ds-segmented-picker.vue";
import PickerItem from "@sazka/design-system/src/segmented-picker-item/ds-segmented-picker-item.vue";
import { DsDropdownItemModel } from "@sazka/design-system/src/forms/components/ds-dropdown/ds-dropdown-models";
import { Lottery } from "@sazka/lotteries/js/models/lottery";
import { getLotteryConfig } from "@sazka/lotteries/js/utils/lottery-configs/get-lottery-config";
import { LotteryParser } from "@sazka/lotteries/js/utils/lottery-parser";
import { useBreakpoints } from "@sazka/utils/composables/use-breakpoints";
import { logNotificationException } from "@sazka/websocket/notifications/composables/use-event-logger";
import PpDrawNumbers from "@/lotteries/product-page/components/results/pp-draw-numbers.vue";
import { useLotteryResults } from "@/lotteries/services/draw-info/pp-results";
import { ProductPageAnalytics } from "./analytics/analytics-product-page";
import PpDrawNumbersRychla6 from "./components/results/pp-draw-numbers-rychla-6.vue";
import PpDrawResultsButtons from "./components/results/pp-draw-results-buttons.vue";
import { usePastDraws } from "./composables/use-past-draws";
import { usePpWagerConfiguration } from "./composables/use-wager-configuration";
import { DrawResultsPickerType } from "./model/draw-results-picker-type";


export default /*@__PURE__*/_defineComponent({
  __name: '_pp-draw-results',
  props: {
    lottery: {}
  },
  setup(__props: any) {

const props = __props;

const { fetchPastDraws, pastDraws } = usePastDraws();
const pastDrawOptions = computed<DsDropdownItemModel[]>(
    () =>
        pastDraws.value?.map((item) => {
            return {
                label: item.name,
                value: item.id,
            };
        }) ?? []
);

const drawResultsSortOrder = ref(DrawResultsPickerType.SortAscending);

const selectedDraw = ref<string | number>();
const lottery = computed(() => LotteryParser.parseLotteryName(props.lottery));

const config = getLotteryConfig(lottery.value);
usePpWagerConfiguration().configure(config);

const enableSort = computed(() => {
    switch (lottery.value) {
        case Lottery.sportka:
        case Lottery.eurojackpot:
        case Lottery.stastnych10:
        case Lottery.euromiliony:
        case Lottery.extraRenta:
        case Lottery.miniRenta:
            return true;
        default:
            return false;
    }
});

const sortByDraw = computed(() => enableSort.value && drawResultsSortOrder.value === DrawResultsPickerType.SortByDraw);

const sm = useBreakpoints("sm");
const showSoftContainer = computed(() => lottery.value !== Lottery.rychla6 || sm.value);

const { results, fetch: fetchResults } = useLotteryResults();

const selectedDateChangeHandler = (id: string | number) => {
    fetchResults(lottery.value, Number(id));
};

ProductPageAnalytics.pushGameCheckbetPageDisplayed(LotteryParser.analyticsCodeName(lottery.value));

onMounted(async () => {
    try {
        await fetchPastDraws(lottery.value);
    } catch (error) {
        logNotificationException("Fetching past draws err", error);
        console.error("Error getting past results", error);
        return;
    }

    selectedDraw.value = pastDraws.value[0].id;
    selectedDateChangeHandler(pastDraws.value[0].id);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(DsDropdown, {
      id: "draw-date",
      options: pastDrawOptions.value,
      "fallback-label": "Načítáme slosování...",
      modelValue: selectedDraw.value,
      "onUpdate:modelValue": [
        _cache[0] || (_cache[0] = ($event: any) => ((selectedDraw).value = $event)),
        selectedDateChangeHandler
      ],
      class: "pp-draw-results__date-select",
      "data-test": "results-date"
    }, null, 8, ["options", "modelValue"]),
    (enableSort.value)
      ? (_openBlock(), _createBlock(DsSegmentedPicker, {
          key: 0,
          modelValue: drawResultsSortOrder.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((drawResultsSortOrder).value = $event)),
          "is-full-width": true,
          size: "lg",
          class: "pp-draw-results__sort-picker"
        }, {
          default: _withCtx(() => [
            _createVNode(PickerItem, {
              title: _unref(DrawResultsPickerType).SortAscending,
              name: _unref(DrawResultsPickerType).SortAscending
            }, null, 8, ["title", "name"]),
            _createVNode(PickerItem, {
              title: _unref(DrawResultsPickerType).SortByDraw,
              name: _unref(DrawResultsPickerType).SortByDraw
            }, null, 8, ["title", "name"])
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true),
    (_unref(results) && lottery.value === _unref(Lottery).rychla6)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass({ 'pp-draw-results__soft-container': showSoftContainer.value })
        }, [
          (lottery.value === _unref(Lottery).rychla6)
            ? (_openBlock(), _createBlock(PpDrawNumbersRychla6, {
                key: 0,
                numbers: _unref(results).numbers
              }, null, 8, ["numbers"]))
            : _createCommentVNode("", true),
          _createVNode(PpDrawResultsButtons, { lottery: lottery.value }, null, 8, ["lottery"])
        ], 2))
      : (_unref(results))
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(PpDrawNumbers, {
              lottery: lottery.value,
              numbers: _unref(results).numbers,
              sortByDraw: sortByDraw.value
            }, null, 8, ["lottery", "numbers", "sortByDraw"]),
            _createVNode(PpDrawResultsButtons, { lottery: lottery.value }, null, 8, ["lottery"])
          ]))
        : _createCommentVNode("", true)
  ], 64))
}
}

})